"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatalayerGa4AnalyticsHandler = void 0;
const react_1 = require("react");
const event_transformation_1 = require("./event-transformation");
const use_datalayer_1 = require("../../lib/use-datalayer");
function pageEvent(data) {
    if (!window) {
        return null;
    }
    const { location, referrer, title } = window.document;
    const { href, pathname, search } = location;
    return {
        event: 'Page Viewed',
        page_properties: {
            path: pathname,
            referrer,
            search,
            title,
            url: href,
            ...data,
        },
    };
}
function useDatalayerGa4AnalyticsHandler(args) {
    const dataLayer = (0, use_datalayer_1.useDataLayer)(args?.dataLayerName ?? 'dataLayer');
    const transformLegacyEvent = (0, react_1.useCallback)((e) => args?.transformLegacyEvent?.(e) ?? null, [args]);
    return (0, react_1.useMemo)(() => ({
        async trackPage(data) {
            const event = pageEvent(data);
            if (event) {
                dataLayer?.push(event);
            }
        },
        async trackEvent(event) {
            dataLayer?.push(...(0, event_transformation_1.transformEventForDatalayerGa4)(event, transformLegacyEvent));
        },
    }), [transformLegacyEvent, dataLayer]);
}
exports.useDatalayerGa4AnalyticsHandler = useDatalayerGa4AnalyticsHandler;
//# sourceMappingURL=analytics-handler.js.map